import React, { useState } from "react";
import Select, {components} from "react-select";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


const DefaultDropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <ArrowDropDownIcon/>
      </components.DropdownIndicator>
    );
  };

const ReactSelectMultiSelect = (props) => {
    const [isClearable, setIsClearable] = useState(true);
    const { name, eleRef, className, options, ValueContainer, styles, onChange, value, isMulti, isClearableCheck, placeholder, defaultValue, components: customComponents, isDisabled, classNamePrefix = 'prov' } = props

    const mergedComponents = {
        DropdownIndicator: DefaultDropdownIndicator,
        ...(customComponents || {}),
        ...(ValueContainer ? { ValueContainer } : {}),
    };

    return (
        <Select
            menuPortalTarget={document.body} menuPosition={'fixed'}
            name={name}
            ref={eleRef}
            className={className}
            classNamePrefix={classNamePrefix}
            options={options}
            isMulti={isMulti}
            isClearable={isClearableCheck ? isClearable : false}
            isDisabled={isDisabled}
            hideSelectedOptions={false}
            components={mergedComponents}
            styles={styles}
            placeholder={placeholder}
            isSearchable={false}
            onChange={onChange}
            value= {value}
            defaultValue={defaultValue}
            closeMenuOnSelect={true}
        />
    );
};

export default ReactSelectMultiSelect;
